module.exports = __webpack_public_path__ + "img/third-2-opened.3f4c4602.webp";